// Decision logic for the axios 401 refresh-and-retry interceptor in utils/api.js.
// Kept dependency-free so it can be unit-tested directly with `node --test`.

/**
 * Whether a 401 for the given request should trigger a session-token refresh + retry.
 *
 * The interceptor retries a request once after refreshing the session access token, on the
 * assumption that the 401 was caused by an expired *session* token. That assumption only holds
 * for requests authenticated with the session token, so we must NOT refresh-and-retry when:
 *   - the request establishes auth itself (`/auth`, `/auth/refresh`), or
 *   - the request carried an explicit auth override (e.g. a password-reset link token). Refreshing
 *     the session can never fix the override token, so retrying re-sends the same bad token and
 *     loops forever (an expired reset-password link would refresh + retry indefinitely).
 *
 * @param {string} url request URL, without the `/api/v1` prefix
 * @param {string|null|undefined} authHeaderOverride explicit Authorization header, if any
 * @returns {boolean}
 */
export function shouldRefreshAndRetryOn401(url, authHeaderOverride) {
    return url !== '/auth/refresh' && url !== '/auth' && !authHeaderOverride;
}
